<template>
  <div class="orderGoods">
    <div class="total">共 {{ cartnum }} 件商品</div>
    <div class="goodWrapper"> 
      <div
        v-for="cart in cartInfo"
        :key="cart.id"
      >
      <div v-for="carts in cart.productInfos" :key="carts.id"   class="item acea-row row-between-wrapper">
        <div class="pictrue">
          <img v-lazy="carts.productInfo.image" alt="img" class="image" />
        </div>
        <div class="text">
          <div class="acea-row row-between-wrapper">
            <div class="name line1">{{ carts.productInfo.store_name }}</div>
            <div class="num">x {{ carts.cart_num }}</div>
          </div>
          <div class="attr line1" v-if="carts.productInfo.attrInfo">
            {{ carts.productInfo.attrInfo.suk }}
          </div>
          <div class="money font-color-red">
            ￥{{
              carts.productInfo.attrInfo
                ? carts.productInfo.attrInfo.price
                : carts.productInfo.price
            }}
          </div>
          <div
            class="evaluate"
            v-if="evaluate === 3"
            @click="$router.push({ path: '/goods_evaluate/' + carts.unique })"
          >
            评价
          </div>
        </div>
      </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "OrderGoods",
  props: {
    evaluate: Number,
    cartInfo: {
      type: Array,
      default: () => []
    }
  },
  data: function() {
    return {
      cartnum:0
    };
  },
  // watch: {
  //   cartInfo:{
  //     handler (newdata,old) { //这是vue的规定写法，当你watch的值发生变化的时候，就会触发这个handler，这是vue内部帮你做的事情
  //       let num = 0;
  //       newdata.map(v=>{
  //         v.productInfos.map(s=>{
  //           num = num+s.cart_num
  //           console.log(s.cart_num)
  //         })
  //       })
  //       this.cartnum = num;
        
  //     },
  //     immediate:true,
  //     deep: true,  // 可以深度检测到 obj 对象的属性值的变化
  //   }
  // },
  watch: {
    cartInfo:{
      handler (newdata,old) { //这是vue的规定写法，当你watch的值发生变化的时候，就会触发这个handler，这是vue内部帮你做的事情
        let num = 0;
        newdata.map(v=>{
          v.productInfos.map(s=>{
            num = num+s.cart_num
            // console.log(s.cart_num)
          })
        })
        this.cartnum = num;
      //   if (window.sessionStorage.getItem("orderFormItem")) {
      //   // 有值代表选择了商店的地址
      //   let that = this;
      //   let orderFormItem = JSON.parse(
      //     window.sessionStorage.getItem("orderFormItem")
      //   );
      //   let category = JSON.parse(window.sessionStorage.getItem("category"));
      //   // 清除存储
      //   window.sessionStorage.removeItem("category");
      //   window.sessionStorage.removeItem("orderFormItem");
      //   that.cartInfo.map((v, k) => {
      //     console.log(v.category, "=========", category);
      //     if (v.category == category) {
      //       // 商店相同 更换地址
      //       console.log("选择商家地址并更换");
      //       v.system_store[0] = orderFormItem;
      //       setTimeout(()=>{
      //         this.$set(this.cartInfo,k,v)
      //       },100);
      //    }
      //   });
      // }
      },
      immediate:true,
      deep: true,  // 可以深度检测到 obj 对象的属性值的变化
    },
    $route(newValue) {
      let that = this;
     
    },
  },
  mounted: function() {
    // let num = 0;
    // console.log('this.cartInfo[0]',this.cartInfo[0])
    // this.cartInfo.map(v=>{
    //   console.log(v,'=====')
    //   v.productInfos.map(s=>{
    //     num = num+s.cart_num
    //     console.log(s.cart_num)
    //   })
    // })
    // this.cartnum=num
  },
  methods: {
  }
};
</script>
